<template>
	<div class="eno-search">
		<transition name="el-fade-in">
			<div class="eno-search-text">
				<i class="el-icon-search search-icon"></i><span class="search-text">搜索</span>
			</div>
		</transition>
	</div>
</template>

<script>
	export default {
		name: 'enoSearch',
		data() {
			return {
			}
		},
		mounted() {
			// window.addEventListener("scroll", this.changeHeadBg);
		},
		methods: {
		},
	
	}
</script>

<style lang='less' scoped>
.eno-search{
	display: flex;
	height: 100%;
	align-items: center;
	color: @mainTextColor;
	width: 44px;
	cursor: pointer;
	
	.eno-search-text{
		cursor: pointer;
		display: flex;
		align-items: flex-end;
		
		.search-icon{
			font-size: 13.5px;
			width: 20px;
			
		}
		
		.search-text{
			width: 30px;
		}
	}
}
</style>